import React, { useEffect, useState, useCallback } from 'react';
import { Card } from 'primereact/card';
import { ProgressSpinner } from 'primereact/progressspinner';
import authService from '../../../services/auth-service';
import { getCurrentBrand } from '../../../helpers/brand';
import '../styles/authentication.less';

const ProviderLogin = ({ providerName, brand }) => {
  const [error, setError] = useState(null);
  const currentBrand = brand || getCurrentBrand();

  const logoPath = currentBrand === 'roomai' ? '/assets/img/roomai-logo.png' : '/assets/img/cloom-logo.png';
  const logoAlt = currentBrand === 'roomai' ? 'RoomAI Logo' : 'Cloom Logo';

  const handleProviderLogin = useCallback(async () => {
    setError(null);

    try {
      // After this call, the user will be redirected to the IDP
      await authService.signInWithIdp(providerName);
    } catch (err) {
      console.error('Provider login error:', err);
      setError(err.message || 'Provider login failed');
    }
  }, [providerName]);

  useEffect(() => {
    if (providerName) {
      handleProviderLogin();
    }
  }, [providerName, handleProviderLogin]);

  return (
    <div className={`new-login-container brand-${currentBrand}`}>
      {/* Left Panel */}
      <div className="login-left-panel">
        <div className="logo-section">
          <div className="cloom-logo">
            <img src={logoPath} alt={logoAlt} className="logo-image" />
          </div>
          {process.env.REACT_APP_ENV_TYPE !== 'prod' && (
            <div className="environment-text">{'開発環境'}</div>
          )}
        </div>
        <div className="version-info">Version: {process.env.REACT_APP_VERSION}</div>
      </div>

      {/* Right Panel */}
      <div className="login-right-panel flex align-items-center justify-content-center">
        <Card className="login-form-container w-full" style={{ maxWidth: '25rem', background: 'transparent', border: 'none', boxShadow: 'none' }}>
          <div className="text-center">
            <h1 className="login-title mb-4">Microsoft でサインイン</h1>

            {error && (
              <div className="p-error mb-4">
                {error}
              </div>
            )}

            <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" />
            <p className="mt-4" style={{ color: 'white' }}>Microsoftにリダイレクトしています...</p>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default ProviderLogin;
